var React = require('react');

function Facebook (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M23.37 0H1.365A1.37 1.37 0 0 0 0 1.375v22.17c0 .76.611 1.375 1.365 1.375h11.847v-9.65H9.988v-3.761h3.224V8.735c0-3.218 1.95-4.971 4.8-4.971 1.366 0 2.54.102 2.881.148v3.364h-1.976c-1.55 0-1.85.743-1.85 1.832v2.4h3.696l-.481 3.762h-3.215v9.65h6.303a1.37 1.37 0 0 0 1.365-1.375V1.375A1.37 1.37 0 0 0 23.37 0"}));
}

Facebook.displayName = "Facebook";

Facebook.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = Facebook;

Facebook.default = Facebook;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/facebook.svg
// module id = 1267
// module chunks = 0